import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SalesDetailPage from './SalesDetailPage';
import { currencyFormatter } from '../utils/reportingUtils';
import { buildGiftCardFilterGroups, buildGiftCardDetailApiFilters } from '../constants/giftCardsFiltersConfig';

export const giftCardsReportPath = (teamId, report) => `/teams/${teamId}/reporting/gift_cards/${report}`;

export const formatCents = (cents) => currencyFormatter.format((cents || 0) / 100);

export const centsKpiCard = (label, key, current, prior) => ({
  label,
  value: formatCents(current[key]),
  current: (current[key] || 0) / 100,
  prior: (prior[key] || 0) / 100,
});

export const countKpiCard = (label, key, current, prior) => ({
  label,
  value: (current[key] || 0).toLocaleString(),
  current: current[key] || 0,
  prior: prior[key] || 0,
});

function ReportingGiftCardsReportPage({ team, report, filterIds, config, ...props }) {
  const [filterOptions, setFilterOptions] = useState({});

  useEffect(() => {
    if (!team?.id) return;
    axios.get(`${giftCardsReportPath(team.id, report)}/filter_options.json`)
      .then((response) => setFilterOptions(response.data || {}))
      .catch((error) => console.error(`Failed to load gift card ${report} filter options`, error));
  }, [team?.id, report]);

  const fullConfig = {
    kpiFromDetailResponse: true,
    salesDataKey: null,
    venueSeriesKey: null,
    overTimeKey: null,
    topCharts: [],
    kpiGridColumns: 4,
    detailResponseKey: 'rows',
    detailEndpoint: (teamId) => `${giftCardsReportPath(teamId, report)}/data.json`,
    exportBasePath: (teamId) => `${giftCardsReportPath(teamId, report)}/export`,
    buildDetailApiFilters: buildGiftCardDetailApiFilters,
    buildFilterGroups: () => buildGiftCardFilterGroups(filterOptions, filterIds),
    filterTitle: 'Filter Gift Cards',
    filterSubtitle: 'Apply filters to narrow gift card data.',
    paginationLabel: 'rows',
    itemLabel: (count) => `row${count !== 1 ? 's' : ''}`,
    ...config,
  };

  return <SalesDetailPage {...props} team={team} config={fullConfig} />;
}

export default ReportingGiftCardsReportPage;
